import { useAuthStore } from "@/stores/useAuth";

export const LegacyStorageKeys = {
  PREMIUM_ACCESS_GRANTED: "premium_access_granted",
  UUID: "app_user_uuid",
  EMAIL: "user_email",
} as const;

export const getLegacyStorageValue = (
  key: (typeof LegacyStorageKeys)[keyof typeof LegacyStorageKeys],
) => localStorage.getItem(key);

export const clearLegacyStorage = (
  key: (typeof LegacyStorageKeys)[keyof typeof LegacyStorageKeys],
) => localStorage.removeItem(key);

const useLegacyStorage = () => {
  const transferStorage = () => {
    const uuidLegacy = getLegacyStorageValue(LegacyStorageKeys.UUID);
    const emailLegacy = getLegacyStorageValue(LegacyStorageKeys.EMAIL);

    const { email, currentUser } = useAuthStore.getState();
    const uuid = currentUser?.id;

    {
      // Legacy identity (app_user_uuid) → deviceId so registration reuses it.
      // Not currentUser: a partial user crashes useIsLoggedIn (providers.length).
      if (uuidLegacy && !uuid) useAuthStore.setState({ deviceId: uuidLegacy });
      clearLegacyStorage(LegacyStorageKeys.UUID);
    }
    if (emailLegacy && !email) {
      useAuthStore.setState({ email: emailLegacy });
      clearLegacyStorage(LegacyStorageKeys.EMAIL);
    }
  };

  return {
    transferStorage,
  };
};

export default useLegacyStorage;
